import React, { useEffect } from "react";
import styles from "../../../styles/pages/login.module.scss";
import { Box, Grid, Typography } from "@mui/material";
import loginImage from "../../../assets/golf.png";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../../ui/CustomButton/CustomButton";
import { SignInMutation } from "../../../api/functions/user.api";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import validationText from "../../../json/messages/validationText";
import { useMutation } from "react-query";
import CustomInput from "../../../components/CustomInput/CustomInput";
import useNotiStack from "../../../hooks/useNotistack";
import { userToken } from "../../../services/utils";
import BrandMotocaddylogo from "../../../assets/MOTOCADDYLogo.png";

const schema = yup.object().shape({
    email: yup
    .string()
    .trim()
    .required(<p style={{ fontSize: "12px" }}>{validationText.error.enter_email}</p>)
    .matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, 'Email address is not valid'),
  password: yup
    .string()
    .max(32)
    .required(validationText.error.enter_password)
    .label("Password")
});

export default function Login() {
  const isAuth = userToken();
  const navigate = useNavigate();
  const { toastSuccess, toastError } = useNotiStack();

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues:{
      email:"",
      password:""
    }
  });

  const { isLoading, mutate, isError } = useMutation(SignInMutation);


  const onSubmit = (data) => {
     if(isError){
        toastError("Something went wrong")
     }

    mutate(
      {
        email: data.email,
        password: data.password,
      },
      {
        onSuccess: (res) => {
          if (res.Status === 1) {
            toastSuccess(res.ErrorMessage);
            localStorage.setItem("adminLevel", res?.administrator);
            localStorage.setItem("portal_key",res.secretKey)
            localStorage.setItem("adminUser_id",res.id_adminuser)
            localStorage.setItem("email",data.email)
            navigate("/dashboard/search-results");

          }else {
            if(res.Status === 216){
              toastError(res?.ErrorMessage)
            }else if(res.Status === 1001){
              toastError(res?.ErrorMessage)
            }
          }
        },
        onError: (res) => {
          toastError("Something went wrong");
        },
      },
    );
  };

  useEffect(() => {
    if(isAuth && isAuth !== null) {
        navigate("/dashboard/search-results");
    }
}, [isAuth]);

  return (
    <Box className={styles.auth_wrapper}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Box className={styles.auth_lft}>
            <figure>
              <img src={loginImage} alt="" />
            </figure>
          </Box>
        </Grid>
        <Grid item xs={12} md={4} className={styles.grid}>
          <Box className={styles.auth_rgt}>
            <Box className={styles.auth_rgt_inr}>
              <Box className={styles.auth_rgt_box}>
                <Link to="/" className={styles.logo}>
                  <img src={BrandMotocaddylogo} alt="" />
                </Link>
                <Typography variant="h3">
                  Customer Management Portal Login
                </Typography>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Box className={styles.form_group}>
                    <Controller
                      control={control}
                      // {...register("email")}
                      name="email"
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          placeholder="Email"
                          type="text"
                          name="email"
                          value={value}
                          onChange={onChange}
                          error={Boolean(errors?.email)}
                          helperText={errors?.email?.message}
                        />
                      )}
                    />
                  </Box>
                  <Box className={styles.form_group}>
                    <Controller
                      control={control}
                      // {...register("password")}
                      name="password"
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          placeholder="Password"
                          type="password"
                          name="password"
                          value={value}
                          onChange={onChange}
                          error={Boolean(errors?.password)}
                          helperText={errors?.password?.message}
                        />
                      )}
                    />
                  </Box>
                  <Box className={styles.btn_group}>
                    <CustomButton type="submit" disabled={isLoading} loading={isLoading}>
                      <Typography variant="caption">Submit</Typography>
                    </CustomButton>
                  </Box>
                </form>
              </Box>
            </Box>
          </Box>
          <Box className={styles.copy_rgt}>
            <Typography variant="body1">
              &copy; 2024 iGolf Inc. All rights reserved.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
